export const ReferralInterstitialNextButtonTappedEvent = {
  feature: 'Referral Interstitial',
  event_description: 'referralInterstitialNext button tapped',
  object: 'Button',
  action: 'Tapped',
  object_name: 'referralInterstitialNext',
  screen: 'referralDisclosureInterstitial',
  screen_name: 'referralDisclosureInterstitial',
}
